import React from 'react';

const ErrorComponent = () => {
	return (
		<div className='text-red-500 bg-red-100 p-5 rounded-lg'>
			Look like component is error
		</div>
	);
};

export default ErrorComponent;